import { render, staticRenderFns } from "./HeaderNotification.vue?vue&type=template&id=5a07e912&scoped=true&"
import script from "./HeaderNotification.vue?vue&type=script&lang=js&"
export * from "./HeaderNotification.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotification.vue?vue&type=style&index=0&id=5a07e912&prod&scoped=true&lang=css&"
import style1 from "./HeaderNotification.vue?vue&type=style&index=1&id=5a07e912&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a07e912",
  null
  
)

export default component.exports